import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { NaviGate } from '../../../Utility/function'

const ProfitLoss_report = () => {
    const location = useLocation()
    const {state} = location
    const [selectedLanguage, setselectedLanguage] = useState('english')

  return (
   <>
    <div className="page-wrappers">
      <div className="page-content py-1">
      <NaviGate />
        <h6 className="mt-3 text-uppercase">Profit&Loss Report</h6>
        <div className="card">
          <div className="card-body">
             <>
                  <div className="row mx-3 mt-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="col-md-1">
                        <img
                          src="assets/images/tech_logo.webp"
                          alt="Left Logo"
                          style={{ maxHeight: "38px" }}
                        />
                      </div>
                      <div>
                        <img
                          src="assets/images/arabic.jpg"
                          alt="Left Logo"
                          style={{ maxHeight: "38px" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mt-4 mx-4">
                    <div
                      className="col-md-12"
                      style={{
                        position: "relative",
                        overflow: "hidden",
                        backgroundSize: "60%",
                        backgroundPosition: "center",
                      }}
                    >
                      <div>
                      <div className='d-flex justify-content-between align-items-center p-2'>
                          <div className='d-flex column-gap-3'>
                            {/* <div className="font-14 cursor-pointer" style={{color:reporttype == 0 ? '#126EFD' : '', textDecoration:reporttype == 0 ? 'underline' : ''}} onClick={()=>setreporttype(0)}>Project Report</div> */}
                            {/* <div className="font-14 cursor-pointer" style={{color:reporttype == 1 ? '#126EFD' : '', textDecoration:reporttype == 1 ? 'underline' : ''}} onClick={()=>setreporttype(1)}>Employee Report</div> */}
                          </div>
                          <div>
                            {/* {reporttype == 1 && 
                          <select class="form-select" onChange={handleEmployeeChange} aria-label="Default select example">
                            <option value="">All Employee</option>
                            {FilterMembers.map((item, index)=>(
                              <option value={item.user_Id}>{item?.full_name}</option>
                            ))}
                          </select>} */}
                          </div>
                        </div>
                        <div className="bg-dark text-white p-2 rounded-top">
                          <h6 className="mb-0 text-center fw-bold">
                          Profit & Loss Report
                          </h6>
                        </div>
                      <div className="table-responsive">
                        {true && (
                          <table className="table table-bordered border-dark">
                            <thead>
                              <tr>
                                <th scope="col" className="bg-light">SL.No</th>
                                <th scope="col" className="bg-light">Date</th>
                                <th scope="col" className="bg-light">Title</th>
                                <th scope="col" className="bg-light" style={{ width: "40%" }}>Description</th>
                                <th scope="col" className="bg-light">Estimated Cost</th>
                                <th scope="col" className="bg-light">Incomes</th>
                                <th scope="col" className="bg-light">Expenses</th>
                              </tr>
                            </thead>
                            {/* <tbody>
                              <tr>
                                <td>1</td>
                                <td>{state?.start_date}</td>
                                <td>{state?.title}</td>
                                <td>{state?.description}</td>
                                <td>{state?.estimation_amount}</td>
                                <td></td>
                                <td></td>
                              </tr>
                              {([...projectTransaction.filter(item => item.is_paid == 1), ...Expenses]
                                .map((item) => ({
                                  date: item.date || item.created_date?.split("T")[0], // Extract date
                                  title: item.title,
                                  description: item.remarks || item.description || "",
                                  estimatedCost: "",
                                  income: item.amount && projectTransaction.includes(item) ? item.amount : "", // Only for projectTransaction
                                  expense: item.amount && Expenses.includes(item) ? item.amount : "", // Only for Expenses
                                }))
                                .sort((a, b) => new Date(a.date) - new Date(b.date)) // Sort by date
                              ).map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 2}</td>
                                  <td>{item.date}</td>
                                  <td>{item.title}</td>
                                  <td>{item.description}</td>
                                  <td>{item.estimatedCost}</td>
                                  <td>{item.income}</td>
                                  <td>{item.expense}</td>
                                </tr>
                              ))}
                            </tbody> */}
                            <tr><br/></tr>
                            <tfoot>
                              <tr>
                                <td colSpan="6" className="bg-transparent fw-bold text-end">
                                  {selectedLanguage === "arabic" ? "الإجمالي" : "Overall Paid Amount"}
                                </td>
                                <td className="bg-transparent">{state?.paid_amount}</td>
                              </tr>

                              <tr>
                                <td colSpan="6" className="bg-transparent fw-bold text-end">
                                  {selectedLanguage === "arabic" ? "الخصم" : "Overall Expenses"}
                                </td>
                                <td className="bg-transparent">{100}</td>
                              </tr>

                              <tr>
                                <td colSpan="6" className="bg-transparent fw-bold text-end">
                                  {selectedLanguage === "arabic" ? "الضريبة" : "Profit"}
                                </td>
                                <td className="bg-transparent">{state?.paid_amount - 100}</td>
                              </tr>
                            </tfoot>
                          </table>
                        )}
                      </div>
                      </div>
                    </div>
                  </div>
                </>
          </div>
        </div>
      </div>  
    </div>  
   </>
  )
}

export default ProfitLoss_report